import React, {useState} from 'react';
import {Box, Button, IconButton, Popover, Tooltip} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export default function DeleteButton({
                                         onClick,
                                         tooltip,
                                         color,
                                         disabled = false,
                                         small = false,
                                         large = false,
                                         confirmPopup = false,
                                         square = false
                                     }) {

    const [anchorEl, setAnchorEl] = useState(null);

    const handleDeleteClick = (event) => {
        event.stopPropagation();
        if (confirmPopup) {
            setAnchorEl(event.currentTarget);
        } else {
            onClick(event);
        }
    };

    const handleConfirmDelete = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
        onClick(event);
    };

    const handleClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    return (
        <>
            {large ?
                <Tooltip title={tooltip}>
                    <Button
                        component="label"
                        variant="text"
                        startIcon={<DeleteIcon/>}
                        onClick={handleDeleteClick}
                        disabled={disabled}
                    >
                        Delete
                    </Button>
                </Tooltip>
                :
                <IconButton
                    edge="start"
                    color={color}
                    onClick={handleDeleteClick}
                    disabled={disabled}
                    size={small ? 'small' : ''}
                    sx={{
                        ...(square && {
                            borderRadius: 0,
                            '&:active': {
                                transform: 'scale(0.85)',
                            },
                        }),
                    }}
                >
                    <Tooltip title={tooltip}>
                        <DeleteIcon/>
                    </Tooltip>
                </IconButton>
            }
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Box p={1} display="flex" gap={1}>
                    <Button disableElevation variant="contained" color="error" size="small" onClick={handleConfirmDelete}>
                        Delete
                    </Button>
                    <Button variant="outlined" size="small" onClick={handleClose}>
                        Cancel
                    </Button>
                </Box>
            </Popover>
        </>
    );
}
